module.exports = __webpack_public_path__ + "static/media/HeaderPhoneMobile.119fb51c.png";